import axios from 'axios';
import {
    MDBContainer,
    MDBSpinner
} from 'mdb-react-ui-kit';
import React, {useContext,  useEffect, useState } from "react";
import ContactContent from './ContactContent';
import { fetchMainPageData } from '../utils/Common';
import { NavbarContext } from '../context/NavProvider';
function Contact() {
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;

    const [contactPageData, setContactPageData] = useState(true);
    const [isContactPageDataEmpty, setIsContactPageDataEmpty] = useState(true);
    const { setIsPricing,setBusiness,setPageData,pageData} = useContext(NavbarContext);
    useEffect(() => {
        if (!pageData) {
          fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);
          
        }
      }, [pageData, setBusiness, setIsPricing, setPageData]);
      

    useEffect(() => {
        const fetchContactPageData = async () => {
            await axios.get(`${baseUrl}/contactpagedata`)
                .then(res => {
                    setIsContactPageDataEmpty(false);
                    setContactPageData(res.data);
                }).catch(e => {
                    console.error("Contact Page data not fuond in Mongo DB");
                    setIsContactPageDataEmpty(true);
                });
        }

        fetchContactPageData();

    }, []);


    return (
        <MDBContainer className="pt-1" >
            {
                isContactPageDataEmpty ?
                    (
                        <div className="text-center">
                            <MDBSpinner className='m-5' role='output'>
                                <span className='visually-hidden'>Loading...</span>
                            </MDBSpinner>
                        </div>
                    ) : (
                        <ContactContent contactPageData={contactPageData} />
                    )
            }
        </MDBContainer>
    );
}


export default Contact;